module.exports = __webpack_public_path__ + "static/media/cabins-business.542ec264.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/cabins-business.png
// module id = 998
// module chunks = 0